import { io, Socket } from "socket.io-client";

let socket: Socket | null = null;

export const getSocket = (): Socket => {
  if (!socket) {
    socket = io('https://websocket.a2zhealth.in', {
      transports: ['websocket'],
      reconnection: true,
      forceNew: false,
    });

    socket.on('connect', () => console.log('✅ Connected SID:', socket?.id));
    socket.on('disconnect', (reason) => console.log('⚡ Disconnected:', reason));

    socket.onAny((event, ...args: any[]) => {
      console.log(`📌 Socket.IO Event: ${event}`, args);
    });
  }
  return socket;
};
